export default __webpack_public_path__ + "1a6654020208b51e8ba53593c47e859d.svg";